import cs from "./cs.json";
import aiMl from "./aiMl.json";
import csb from "./csb.json";
import csd from "./csd.json";
import ec from "./ec.json";
import is from "./is.json";
import me from "./me.json";
import sh from "./sh.json";
import aiDs from "./aiDs.json";
import mca from "./mca.json";
import mba from "./mba.json";
export const allDepartmentsData = [
  aiMl,
  aiDs,
  cs,
  csb,
  csd,
  ec,
  is,
  me,
  sh,
  mca,
  mba,
];